import * as React from 'react';
import CenteredPageContainer from '../../components/CenteredPageContainer';
import { Container, Row, Col, Collapse } from 'reactstrap';
import NavBar from '../../components/NavBar';
import VolumeSelectors from '../../components/FormComponents/VolumeSelectors';
import AboutYouForm from '../../components/FormComponents/AboutYouForm';
import { withRouter, RouteComponentProps } from 'react-router-dom';
import AddressInputForm from '../../components/FormComponents/AddressInputForm';
import DatePicker from '../../components/FormComponents/DatePicker';
import RectangleButton from '../../components/Buttons/RectangleButton';
import * as moment from 'moment';
import FormTitleText from '../../components/FormComponents/FormTitleText';
import FormTitleNumber from '../../components/FormComponents/FormTitleNumber';
import FormDetailText from '../../components/FormComponents/FormDetailText';
import { geocodeByAddress, getLatLng } from 'react-places-autocomplete';
import * as EmailValidator from 'email-validator';

interface state {
  currentStep: number;
  startDate: moment.Moment | null;
  endDate: moment.Moment | null;
  address: string;
  standardBoxes: number;
  mediumItems: number;
  largeItems: number;
  extraLargeItems: number;
  enormousItems: number;
  loading: boolean;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  email: string;
}

class GettingStartedPage extends React.Component<RouteComponentProps<any>, state> {
  goToStep = (invalid: boolean, step: number) => {
    if (!invalid) {
      this.setState({ currentStep: step });
    }
  };

  getMatched = async (invalid: boolean) => {
    if (!invalid) {
      const results = await geocodeByAddress(this.state.address);
      const { lat, lng } = await getLatLng(results[0]);
      this.props.history.push({
        pathname: '/match',
        state: {
          lat,
          lng,
          startDate: this.state.startDate != null ? this.state.startDate.toISOString() : null,
          endDate: this.state.endDate != null ? this.state.endDate.toISOString() : null,
          address: this.state.address,
          standardBoxes: this.state.standardBoxes,
          mediumItems: this.state.mediumItems,
          largeItems: this.state.largeItems,
          extraLargeItems: this.state.extraLargeItems,
          enormousItems: this.state.enormousItems,
          email: this.state.email,
          firstName: this.state.firstName,
          lastName: this.state.lastName,
          phoneNumber: this.state.phoneNumber,
        },
      });
    }
  };

  state = {
    currentStep: 1,
    startDate: moment('05-10-2019', 'MM-DD-YYYY'),
    endDate: null as moment.Moment | null,
    address: '',
    standardBoxes: 0,
    mediumItems: 0,
    largeItems: 0,
    extraLargeItems: 0,
    enormousItems: 0,
    loading: false,
    firstName: '',
    lastName: '',
    phoneNumber: '',
    email: '',
  };

  render() {
    const invalidStorageDates =
      this.state.startDate == null || this.state.endDate == null || this.state.address === '';
    const invalidVolume =
      this.state.standardBoxes === 0 &&
      this.state.mediumItems === 0 &&
      this.state.largeItems === 0 &&
      this.state.extraLargeItems === 0 &&
      this.state.enormousItems === 0;
    const invalidAboutYou =
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.phoneNumber === '' ||
      !EmailValidator.validate(this.state.email);
    return (
      <CenteredPageContainer>
        <NavBar />
        <Container style={{ marginTop: 25 }}>
          <Row>
            <Col xs={{ size: 12 }} md={{ size: 8, offset: 2 }} lg={{ size: 4, offset: 4 }}>
              <div>
                <FormTitleText
                  isActive={this.state.currentStep >= 1}
                  onClick={() => this.setState({ currentStep: 1 })}
                >
                  <FormTitleNumber isActive={this.state.currentStep >= 1}>1</FormTitleNumber>
                  Storage Dates & Location
                </FormTitleText>
                <Collapse isOpen={this.state.currentStep === 1}>
                  <FormDetailText>
                    From the day you drop off your items to the day you pick them up.
                  </FormDetailText>
                  <DatePicker
                    style={{ marginBottom: 8, maxWidth: '100vw' }}
                    onChange={(startDate, endDate) => this.setState({ startDate, endDate })}
                    startDate={this.state.startDate}
                  />
                  <AddressInputForm onChange={value => this.setState({ address: value })} />
                  <RectangleButton
                    invalid={invalidStorageDates}
                    onClick={() => {
                      this.goToStep(invalidStorageDates, 2);
                    }}
                    style={{ marginTop: 20 }}
                  >
                    Next
                  </RectangleButton>
                </Collapse>
              </div>

              <div style={{ paddingTop: 40 }}>
                <FormTitleText
                  isActive={this.state.currentStep >= 2}
                  onClick={() => this.goToStep(invalidStorageDates, 2)}
                >
                  <FormTitleNumber isActive={this.state.currentStep >= 2}>2</FormTitleNumber>
                  Storage Volume
                </FormTitleText>
                <Collapse isOpen={this.state.currentStep === 2}>
                  <FormDetailText style={{ marginBottom: 20 }}>
                    Give us your best estimate of how much you’re storing. You can always adjust
                    this later.
                  </FormDetailText>

                  <VolumeSelectors
                    onStandardBoxChange={standardBoxes => {
                      this.setState({ standardBoxes });
                    }}
                    onMediumChange={mediumItems => {
                      this.setState({ mediumItems });
                    }}
                    onLargeChange={largeItems => this.setState({ largeItems })}
                    onExtraLargeChange={extraLargeItems => this.setState({ extraLargeItems })}
                    onEmormousChange={enormousItems => this.setState({ enormousItems })}
                  />

                  <RectangleButton
                    invalid={invalidVolume}
                    onClick={() => {
                      this.goToStep(invalidVolume || invalidStorageDates, 3);
                    }}
                    style={{ marginTop: 20 }}
                  >
                    Next
                  </RectangleButton>
                </Collapse>
              </div>

              <div style={{ paddingTop: 40 }}>
                <FormTitleText
                  isActive={this.state.currentStep >= 3}
                  onClick={() => this.goToStep(invalidVolume || invalidStorageDates, 3)}
                >
                  <FormTitleNumber isActive={this.state.currentStep >= 3}>3</FormTitleNumber>
                  About You
                </FormTitleText>
                <Collapse isOpen={this.state.currentStep === 3}>
                  <FormDetailText>Let's get to know you a little better.</FormDetailText>
                  <AboutYouForm
                    onChange={(firstName, lastName, phoneNumber, email) => {
                      this.setState({ firstName, lastName, phoneNumber, email });
                    }}
                  />
                  <RectangleButton
                    invalid={invalidStorageDates || invalidVolume || invalidAboutYou}
                    style={{ marginTop: 20 }}
                    onClick={() => {
                      this.getMatched(invalidStorageDates || invalidVolume || invalidAboutYou);
                    }}
                  >
                    Get Matched
                  </RectangleButton>
                </Collapse>
              </div>
            </Col>
          </Row>
        </Container>
      </CenteredPageContainer>
    );
  }
}
export default withRouter(GettingStartedPage);



// WEBPACK FOOTER //
// ./src/pages/GettingStarted/GettingStartedPage.tsx